import { Component } from 'react';
import { sanitizeUserInput } from '~/utils/sanitize-user-input';

export default class DefaultSearchResult extends Component {
  componentDidUpdate() {
    if (this.props.isActive) {
      this.activeItem?.scrollIntoView({
        // scrolls only if element is about to go off viewable list
        block: 'nearest',
      });
    }
  }

  render() {
    let { name, content, status, onSelect } = this.props;
    const activeClass = this.props.isActive ? 'default-search-result--active' : '';

    status = status && status.trim();
    name = name && name.trim();
    content = content && content.trim();

    const formattedContent = content ? (
      <div
        className="default-search-result--content"
        dangerouslySetInnerHTML={{ __html: sanitizeUserInput(content) }}
      />
    ) : undefined;
    const formattedStatus = status ? <div className="default-search-result--status">{status}</div> : undefined;

    return (
      <div
        ref={(activeItem) => {
          this.activeItem = activeItem;
        }}
        className={`default-search-result ${activeClass}`}
        onClick={onSelect}
      >
        <div className="default-search-result--inner">
          {this.getIcon()}
          <div className="default-search-result--label">
            <div
              className="default-search-result--title"
              dangerouslySetInnerHTML={{ __html: sanitizeUserInput(name) }}
            />
            {formattedContent}
          </div>
          {formattedStatus}
        </div>
        <div className="default-search-result--mask" />
      </div>
    );
  }

  getIcon = () => {
    const { icon } = this.props;
    if (!icon) return;

    const isUrl = typeof icon === 'string';
    if (isUrl) return <img src={icon} className="default-search-result--icon" />;
    return icon;
  };
}
